(function () {
  var mediaByVariant = {
    '45364794228805': '32234605183045',
    '45364794261573': '32234605183045',
    '45364794294341': '32234605183045',
    '45364794327109': '32234605183045',
    '45364794359877': '32234605183045',
    '45364794392645': '32234605477957',
    '45364794425413': '32234605477957',
    '45364794458181': '32234605477957',
    '45364794490949': '32234605477957',
    '45364794523717': '32234605477957'
  };

  function syncMainImage() {
    var variant = document.querySelector('[name="id"]');
    var mediaId = variant && mediaByVariant[variant.value];
    if (!mediaId) return;

    var slideshow = document.querySelector('#ProductPhotos-template--20265478062149__main');
    if (!slideshow) return;

    var target = slideshow.querySelector('.product-main-slide[data-media-id="' + mediaId + '"]');
    if (!target) return;

    slideshow.querySelectorAll('.product-main-slide').forEach(function (slide) {
      var active = slide === target;
      slide.style.display = active ? 'block' : 'none';
      slide.classList.toggle('starting-slide', active);
      slide.classList.toggle('secondary-slide', !active);
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('input[type="radio"], select')) window.setTimeout(syncMainImage, 0);
  });
  document.addEventListener('variant:change', function () { window.setTimeout(syncMainImage, 0); });
  document.addEventListener('DOMContentLoaded', syncMainImage);
  window.setTimeout(syncMainImage, 400);
})();
